import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { LocalStorageService } from '../../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';

@Component({
    selector: 'kiene-bestandsbesuchsprotokoll-uebersicht',
    templateUrl: './bestandsbesuchsprotokoll-uebersicht.component.html',
    styleUrls: ['./bestandsbesuchsprotokoll-uebersicht.component.scss'],
})
export class BestandsbesuchsprotokollUebersichtComponent implements OnInit {
    selectedTab = 0;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private readonly localStorageService: LocalStorageService,
    ) {
        this.route.queryParams.subscribe(params => {
            const tabName = params['tab'];
            if (tabName) {
                if (tabName === 'bestandsbesuchsprotokoll') {
                    this.selectedTab = 0;
                } else if (tabName === 'tierwohlprotokoll-rind') {
                    this.selectedTab = 1;
                } else if (tabName === 'tierwohlprotokoll-schwein') {
                    this.selectedTab = 2;
                } else if (tabName === 'biosicherheitsplan-schwein') {
                    this.selectedTab = 3;
                } else if (tabName === 'evaluationsbogen-schwein') {
                    this.selectedTab = 4;
                } else if (tabName === 'biosicherheitsplan-rind') {
                    this.selectedTab = 5;
                }
            }
            this.ensureAllowedTab();
        });
    }

    ngOnInit() {}

    setSelectedTab(event: MatTabChangeEvent) {
        const id = event.index;
        this.selectedTab = id;
        this.ensureAllowedTab();
        this.router
            .navigate([], {
                relativeTo: this.route,
                queryParams: { tab: this.getTabName(id) },
                queryParamsHandling: 'merge',
            })
            .then();
    }

    getTabName(id: number) {
        if (id === 0) {
            return 'bestandsbesuchsprotokoll';
        } else if (id === 1) {
            return 'tierwohlprotokoll-rind';
        } else if (id === 2) {
            return 'tierwohlprotokoll-schwein';
        } else if (id === 3) {
            return 'biosicherheitsplan-schwein';
        } else if (id === 4) {
            return 'evaluationsbogen-schwein';
        } else {
            return 'biosicherheitsplan-rind';
        }
    }

    get disableBiosicherheitsplanSchweinTab(): boolean {
        const currentClient = this.localStorageService.getCurrentClient();
        if (!currentClient) {
            return false;
        }
        return LocalStorageService.isClientRind(currentClient) && !LocalStorageService.isClientSchwein(currentClient);
    }

    get disableBiosicherheitsplanRindTab(): boolean {
        const currentClient = this.localStorageService.getCurrentClient();
        if (!currentClient) {
            return false;
        }
        return LocalStorageService.isClientSchwein(currentClient) && !LocalStorageService.isClientRind(currentClient);
    }

    private ensureAllowedTab(): void {
        if (
            (this.selectedTab === 3 || this.selectedTab === 4) &&
            this.disableBiosicherheitsplanSchweinTab
        ) {
            this.selectedTab = 5;
            return;
        }
        if (this.selectedTab === 5 && this.disableBiosicherheitsplanRindTab) {
            this.selectedTab = 3;
        }
    }
}
